// Speed Card V1 · S2 — the IFRS statements are kept per engagement (backend figures_store.py). When the current statements are
// not built yet (an input or the code changed since the last build) the statement calls answer at once with the LAST built
// statements and `stored` = { state: "stale", computed_at }: the screen shows them with "Updating… (figures as of DD-MMM-YYYY
// HH:mm)" (the dashboard's wording, StoredUpdating) and reloads them every few seconds, without blanking them, until the
// current ones come. Validation and the sign-off preflight never answer from an earlier build (they wait for the current one).
import React, { useEffect } from "react";
import api from "@/lib/api";
import UpdatingNote, { isUpdating } from "@/components/dashboard/StoredUpdating";

export const IFRS_POLL_MS = 4000;
export const STATEMENT_KEYS = ["sfp", "pl", "soce", "cash-flow", "notes"];

export function statementsStored(...replies) {
  return replies.map((r) => r && r.stored).find((s) => isUpdating(s)) || null;
}

// setters: { sfp: setSfp, pl: setPl, soce: setSoce, "cash-flow": setCashFlow, notes: setNotes }
export function useIfrsStoredPoll(engId, stored, setters) {
  useEffect(() => {
    if (!engId || !isUpdating(stored)) return undefined;
    let live = true;
    const id = setTimeout(() => {
      STATEMENT_KEYS.forEach((k) => {         // all five together, each shown as it comes (as the screen's first load)
        api.get(`/fs/${engId}/${k}`, { _silent: true })
          .then((r) => { if (live && setters[k]) setters[k](r.data); })
          .catch(() => { /* the screen keeps what it shows */ });
      });
    }, IFRS_POLL_MS);
    return () => { live = false; clearTimeout(id); };
  }, [engId, stored]);   // eslint-disable-line react-hooks/exhaustive-deps
}

export default function IfrsUpdating({ stored, t }) {
  if (!isUpdating(stored)) return null;
  return (
    <div data-testid="ifrs-stored-updating" className="mt-1">
      <UpdatingNote stored={stored} t={t} testid="ifrs-updating" />
      <span className="block text-xs text-muted-foreground" data-testid="ifrs-updating-hint">{t("speed1.ifrsHint")}</span>
    </div>
  );
}
